<template>
  <div class="pdt-skeleton-container">
    <div class="pdt-skeleton-container-header">
      <Skeleton height="20px" width="150px" borderRadius="4px" />
    </div>
    <div class="pdt-skeleton-container-main">
      <div class="pdt-skeleton-container-main-middle">
        <Skeleton width="485px" height="40px" borderRadius="4px" />
        <Skeleton width="142px" height="18px" borderRadius="4px" />
      </div>
    </div>
    <div class="pdt-skeleton-container-footer">
      <div class="pdt-skeleton-container-footer-left">
        <Skeleton width="20px" height="20px" borderRadius="4px" />
        <Skeleton width="206px" height="16px" borderRadius="4px" />
      </div>
      <div class="pdt-skeleton-container-footer-right">
        <Skeleton width="212px" height="40px" borderRadius="6px" />
      </div>
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@/components/Skeleton/Skeleton';
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.pdt-skeleton-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  padding-bottom: 24px;
  border-radius: 8px;
  border: 1px solid $colorD20;
  background: $colorN00;
  &-header,
  &-footer {
    display: flex;
    align-items: center;
    gap: 16px;
    align-self: stretch;
  }

  &-main,
  &-footer-left,
  &-footer-right,
  &-main-middle {
    display: flex;
  }

  &-header {
    padding: 24px 24px 16px 24px;
    border-bottom: 0.5px solid $colorD20;
  }

  &-main {
    padding: 0 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;

    &-middle {
      align-items: center;
      gap: 12px;
      flex: 1 0 0;
    }
  }

  &-footer {
    padding-right: 24px;
    justify-content: flex-end;

    &-left {
      align-items: center;
      gap: 8px;
    }

    &-right {
      justify-content: center;
      align-items: center;
      gap: 2px;
    }
  }
}
</style>
